module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-17.88c65050.png";